module.exports = __webpack_public_path__ + "img/home_ic_defense.93b07124.png";